import { get } from 'lodash';
import {
  LogLevel,
  IntervalScheduler,
  Log
} from 'amazon-chime-sdk-js';
import UAParser from 'ua-parser-js';

import siteConfig from '~/config';
import getBrowserDetails from '../helpers/getBrowserDetails';

export default class CustomMeetingSessionPOSTLogger {
  constructor(name, getMeetingConfig, batchSize, intervalMs, url, consoleLogLevel, cloudWatchLogLevel) {
    this.name = name;
    this.getMeetingConfig = getMeetingConfig;
    this.intervalMs = intervalMs;
    this.url = url;
    this.logCapture = [];
    this.sequenceNumber = 0;
    this.lock = false;
    this.consoleLogLevel = consoleLogLevel;
    this.cloudwatchLogLevel = cloudWatchLogLevel;
    this.intervalScheduler = new IntervalScheduler(this.intervalMs);
    this.startLogPublishScheduler(this.batchSize);
    // TODO: move the browser details to a higher level
    //       since we will want to access them in other areas
    //       of the application. They're also used
    //       in DevicePermissions
    this.browserDetails = new UAParser().getResult() || {};
    const GlobalAny = global;
    GlobalAny['window']['addEventListener'] && // eslint-disable-line
      window.addEventListener('unload', () => {
        this.stop();
      });
  }

  debug(debugFunction) {
    if (LogLevel.DEBUG < this.cloudwatchLogLevel) {
      return;
    }
    this.log(LogLevel.DEBUG, debugFunction());
  }

  info(msg) {
    this.log(LogLevel.INFO, msg);
  }

  warn(msg) {
    this.log(LogLevel.WARN, msg);
  }

  error(msg) {
    this.log(LogLevel.ERROR, msg);
  }

  getLogCaptureSize() {
    return this.logCapture.length;
  }

  startLogPublishScheduler(batchSize) {
    this.intervalScheduler.start(async () => {
      if (this.lock === true || this.getLogCaptureSize() === 0 || !this.url) {
        return;
      }
      this.lock = true;
      const batch = this.logCapture.slice(0, batchSize);
      const body = this.makeRequestBody(batch);
      try {
        const response = await fetch(this.url, {
          method: 'POST',
          body,
        });
        if (response.status === 200) {
          this.logCapture = this.logCapture.slice(batch.length);
        }
      } catch (error) {
        window.console.warn(`[MeetingSessionPOSTLogger] ${error.message}`);
      } finally {
        this.lock = false;
      }
    });
  }

  stop() {
    this.intervalScheduler.stop();
    const body = this.makeRequestBody(this.logCapture);
    navigator.sendBeacon(this.url, body);
  }

  makeRequestBody(batch) {
    return JSON.stringify({
      meetingId: get(this.getMeetingConfig(), ['meetingId'], 'PRE_MEETING'),
      attendeeId: get(this.getMeetingConfig(), ['credentials', 'attendeeId'], 'PRE_MEETING'),
      appName: this.name,
      logs: batch,
    });
  }

  log(type, msg) {
    this.consoleLog(type, msg);
    if (type < this.cloudwatchLogLevel) {
      return;
    }
    const date = new Date();
    this.logCapture.push(new Log(this.sequenceNumber, msg, date.getTime(), LogLevel[type]));
    this.sequenceNumber += 1;
  }

  consoleLog(type, msg) {
    if (type < this.consoleLogLevel) {
      return;
    }

    const timestamp = new Date().toISOString();
    const logMessage = `${timestamp} [${LogLevel[type]}] ${this.name} - ${msg}`;

    switch (type) {
      case LogLevel.ERROR:
        window.console.trace(logMessage);
        break;
      case LogLevel.WARN:
        window.console.warn(logMessage);
        break;
      case LogLevel.DEBUG:
        window.console.debug(logMessage.replace(/\\r\\n/g, '\n'));
        break;
      case LogLevel.INFO:
        window.console.info(logMessage);
        break;
      default:
        break;
    }
  }
}
